import type { FunctionComponent } from 'react';
import Link from 'next/link';
import classes from './Header.module.css';
import NavigationMobile from '@/components/layouts/AppShell/NavigationMobile';
import ProgramPageHeader from '@/components/ProgramPageHeader';
import { useAuthentication } from '@/contexts/Authentication';
import PatientProfileDrawer from '@/components/layouts/AppShell/PatientProfileDrawer';
import Icon from '@/components/Icon';

export interface HeaderProps {
  withNavigation?: boolean;
  withLoginLink?: boolean;
  withProfileDrawer?: boolean;
  closeHref?: string;
}

const Header: FunctionComponent<HeaderProps> = ({
  withNavigation = true,
  withProfileDrawer = true,
  withLoginLink = false,
  closeHref,
}) => {
  const { authenticated } = useAuthentication();

  const showLoginLink = withLoginLink && !authenticated;
  const showCloseButton = !showLoginLink && !!closeHref;
  const showProfileDrawer = !showLoginLink && withProfileDrawer;

  return (
    <ProgramPageHeader
      centerSection={
        withNavigation && (
          <div className={classes.navigationContainer}>
            <NavigationMobile />
          </div>
        )
      }
      rightSection={
        <>
          {showLoginLink && (
            <Link href="/auth/login" className={classes.loginLink}>
              Log In
            </Link>
          )}
          {showCloseButton && (
            <Link
              href={closeHref}
              className={classes.loginLink}
              aria-label="Close">
              <Icon name="feather/x" size="md" />
            </Link>
          )}
          {showProfileDrawer && <PatientProfileDrawer />}
        </>
      }
    />
  );
};

export default Header;
